module.exports = __webpack_public_path__ + "img/spin_btn.858df3ce.png";